export function ShipPageLayout({ children }) {
  return (
    <main className="flex flex-col items-center min-h-[calc(100vh-60px)] py-16 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-5xl">{children}</div>
    </main>
  );
}